import { useJsApiLoader } from '@react-google-maps/api';

/**
 * Single shared libraries list for the whole app.
 * Loading Maps twice (useLoadScript vs useJsApiLoader, or different library
 * sets) makes AdvancedMarkerElement reject the Map as "not an instance of
 * MapsApiMap".
 */
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'drawing', 'marker'];

/** @deprecated Use GOOGLE_MAPS_LIBRARIES — kept for any external imports. */
export const GOOGLE_MAPS_MARKER_LIBRARIES = GOOGLE_MAPS_LIBRARIES;

/** @deprecated Use GOOGLE_MAPS_LIBRARIES — kept for any external imports. */
export const GOOGLE_MAPS_BASIC_LIBRARIES = GOOGLE_MAPS_LIBRARIES;

const GOOGLE_MAPS_SCRIPT_ID = 'continuity-coach-google-maps';

export function getGoogleMapsApiKey() {
  const raw = process.env.REACT_APP_API_GOOGLE_MAP;
  if (!raw) return '';

  try {
    return new URL(raw).searchParams.get('key') || '';
  } catch {
    return raw;
  }
}

/** Map ID from Google Cloud Console (required for AdvancedMarkerElement). */
export function getGoogleMapId() {
  return String(process.env.REACT_APP_GOOGLE_MAP_ID || '').trim();
}

export function canUseAdvancedMapMarkers() {
  return Boolean(getGoogleMapId() && getGoogleMapsApiKey());
}

/** One Maps JS load for address search, geocoding, and Advanced Markers. */
export function useGoogleMapsApi() {
  const mapId = getGoogleMapId();

  return useJsApiLoader({
    id: GOOGLE_MAPS_SCRIPT_ID,
    googleMapsApiKey: getGoogleMapsApiKey(),
    libraries: GOOGLE_MAPS_LIBRARIES,
    mapIds: mapId ? [mapId] : [],
  });
}
